<template>
	<div
		class="billing-plan-block"
		:class="{'active': currentUser.plan.includes(name)}"
	>
		<h3>{{ title }}</h3>
		<span class="price">${{ price }}/month</span>
		<div class="runs-out" >
			<p
				v-if="runsOut && currentUser.plan.includes(name) && currentUser.plan !== 'Free'"
			>Runs out <span>{{ runsOut }}</span></p>
		</div>
		<strong class="subtitle">Max GB</strong>
		<span class="value">{{ max_gb }}</span>
		<strong class="subtitle">Max Projects</strong>
		<span class="value">{{ max_projects }}</span>
		<strong class="subtitle">Max Members</strong>
		<span class="value">{{ max_members }}</span>
		<strong class="subtitle">Max Tasks</strong>
		<span class="value">{{ max_tasks }}</span>
		<strong class="subtitle">Max Screen Rec Time</strong>
		<span class="value">{{ max_rec_time }} min</span>
		<strong class="subtitle">Draw Images</strong>
		<span class="value">{{ draw_images ? 'Yes' : 'No' }}</span>
		<div class="btn-holder">
			<VButton v-if="!currentUser.plan.includes(name) && name !== 'Trial' && name !== 'Free'" @clickHandler="upgradePlan" active>Upgrade</VButton>
			<VButton v-if="!currentUser.plan.includes(name) && name == 'Free'" @clickHandler="upgradePlan" active>Switch</VButton>
		</div>
	</div>
</template>

<script>
import VButton from "@/components/atoms/VButton";

export default {
	name: 'BillingPlan',
	props: ['title', 'name', 'price', 'max_gb', 'max_projects', 'max_members', 'max_tasks', 'max_rec_time', 'draw_images'],
	components: {
		VButton,
	},
	computed: {
		currentUser() {
			return this.$store.getters.currentUser
		},
		runsOut() {
			return this.formatDateFromTimestamp(this.currentUser.activated_at, this.currentUser.renew_month)
		},
	},
	methods: {
		upgradePlan() {
			if(this.name == 'Free' && !this.currentUser.plan.includes('Free')) {
				window.location = 'https://billing.stripe.com/p/login/6oE8zP5eJ0As5CobII'
			} else if(this.name == 'Pro') {
				window.location = `https://buy.stripe.com/28o2be3RfaTbeJOfZ8`
			} else if(this.name == 'Corporate') {
				window.location = `https://buy.stripe.com/5kAaHKevTbXf9pufZ7`
			}
		},
		formatDateFromTimestamp(timestamp, expires) {
			const date = new Date(timestamp * 1000);

			const year = date.getFullYear();
			let month = date.getMonth() + 1;
			const day = date.getDate();

			if (expires) month = month + expires
			
			if (month > 12) {
				let lengthBetween = month - 12
				month = lengthBetween
			}

			const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;

			return formattedDate;
		}
	}
}
</script>

<style lang="scss">
.billing-plan-block {
	text-align: center;
	font-size: 16px;
	color: var(--primary-text);
	border-radius: 10px;
	padding: 20px 10px;

	&.active {
		background-color: var(--hover);

		h3 {
			color: var(--accent);
		}

		.runs-out span {
			color: var(--accent);
		}
	}

	h3 {
		font-size: 24px;
		margin-bottom: 5px;
		font-weight: 400;
	}

	.subtitle {
		color: #777;
		display: block;
		margin-bottom: 5px;
		font-weight: 400;
	}

	.value {
		display: block;
		margin-bottom: 15px;
		font-size: 24px;
	}

	.price {
		display: block;
		margin-bottom: 5px;
	}

	.runs-out {
		min-height: 26px;
		margin-bottom: 20px;

		p {
			margin-bottom: 0;
		}
	}

	.btn-holder {
		min-height: 40px;
	}
}
</style>